export default [
  {
    motive: 'machinery.usage.unplanned.work',
  },
  {
    motive: 'demolitions.or.overexcavations',
  },
  {
    motive: 'extraction.refrigerant.gases.from.equipment',
  },
  {
    motive: 'equipment.emitting.other.gases.emissions.on.start.up',
  },
  {
    motive: 'demolitions.or.overexcavations',
  },
  {
    motive: 'generator.or.cranes.unplanned.activities',
  },
  {
    motive: 'night.work',
  },
  {
    motive: 'machinery.breakdowns.or.tank.failures.equipment.emptying',
  },
  {
    motive: 'unplanned.activities.or.failures.execution',
  },
  {
    motive:
      'waste.due.fires.or.explosions.welding.work.performed.not.performed',
  },
  {
    motive: 'waste.due.fires.or.explosions.fuel.tank.pipelines.gas.tanks',
  },
  {
    motive:
      'waste.due.fires.explosions.transformer.generator.equipment.fires.explosions',
  },
  {
    motive: 'waste.fires.explosions.gas.pipelines.equipment.welding.works',
  },
  {
    motive: 'waste.due.fires.explosions.breakage.gas.pipelines.tanks.fuel.tank',
  },
  {
    motive:
      'waste.due.fires.explosions.breakage.gas.tanks.transformer.fires.explosions',
  },
  {
    motive: 'fire.extinguishing.welding.works',
  },
  {
    motive: 'fire.extinguishing.fuel.tank.pipelines.gas.tanks',
  },
  {
    motive: 'fire.extinguishing.generator.equipment.fires.explosions',
  },
  {
    motive: 'water.pipelines.sewer.pipelines',
  },
  {
    motive:
      'breakage.electrical.telephone.optical.fiber.signaling.marking.pipelines.etc',
  },
];
